import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { processLink } from "../../utils/shortPinItem";


export const LinkmoveInFolder = createAsyncThunk(
  "link/moveInFolder",
  async ({ token, folderId, id }, { rejectWithValue }) => {


    try {

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/links/folders/move-in-folder`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            linkId: id, folderId
          }
        }
      );

      if (response.data.status) {
        // console.log(response.data.response);
        return {
          key: id,
          folderId: folderId,
          response: response.data.response
        }
      } else {
        return rejectWithValue("Failed to Add in folder");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data || "Error to add in folder "
      );
    }
  }
);



export const toggleKeyStatus = createAsyncThunk(
  "link/toggleKeyStatus",
  async ({ key, token }, { rejectWithValue }) => {

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/links/key/${key}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        // console.log(response.data.response);
        return response.data.response;
      } else {
        return rejectWithValue("Failed to toggle key status");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data || "Error toggling key status"
      );
    }
  }
);


export const deleteShortLink = createAsyncThunk(
  "link/deleteShortLink",
  async ({ key, token }, { rejectWithValue }) => {
    try {
      const encodedKey = encodeURIComponent(key)
      // console.log(typeof(key))
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/links/key?key=${encodedKey}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (response.status === 200 || response.statusCode === 200) {
        return { key, response: response.data };
      } else {

        return rejectWithValue(response.data?.message || "Failed to delete link");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error deleting link");
      return rejectWithValue(
        error.response?.data?.message || error.message || "Network error"
      );
    }
  }
);


export const updateLink = createAsyncThunk(
  "link/updateLink",
  async ({ id, formData, token }, { rejectWithValue }) => {
    try {

      console.log(formData)
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/links/key/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        // console.log(response.data)

        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating link");
    }
  }
);

// =========================
// Get Link By Key
// =========================
export const getLinkByKey = createAsyncThunk(
  "link/getLinkByKey",
  async ({ key, token }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/links/key/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        // console.log(response.data)
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch link");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching link");
    }
  }
);

// =========================
// Get Links List
// =========================
export const getLinks = createAsyncThunk(
  "link/get-links",
  async ({ token, offset = 1, limit = 10, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/links`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            offset: offset,
            limit: limit,
            onlyMy
          }
        }
      );

      if (response.data.status) {
        // console.log(response.data)
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch links");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

export const shortenLinkLoggedMulti = createAsyncThunk(
  "link/shorten-link-logged-Multi",
  async ({ data, token, }, { rejectWithValue }) => {
    try {

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/links/multi`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

        }
      );

      if (response.data.status) {

        return response.data;
      } else {
        return rejectWithValue("Failed to shorten URL");
      }
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  }
);


export const shortenLinkLogged = createAsyncThunk(
  "link/shorten-link-logged",
  async ({ data, token, queryParams }, { rejectWithValue }) => {
    try {
      // console.log(data, queryParams, token)
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/links/custom`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

        }
      );

      if (response.data.status) {
        // console.log(response.data)
        return response.data;
      } else {
        return rejectWithValue("Failed to shorten URL");
      }
    } catch (error) {
      toast.error(error.response?.data?.message)
      return rejectWithValue(error.message || "Network error");
    }
  }
);


export const shortenLinkFree = createAsyncThunk(
  "link/shorten-link-free",
  async ({ url }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/links`,
        { url }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to shorten URL"
      );
    }
  }
);

// =========================
// Initial State
// =========================
const initialState = {
  shortenLinksfree: JSON.parse(localStorage.getItem("shortenLinkFree")) || [],
  shortenedLinks: [],
  loading: false,
  error: null,
};

// =========================
// Slice Definition
// =========================
const shortenLinkSlice = createSlice({
  name: "shortenLink",
  initialState,
  reducers: {
    toggleKeyStatusOptimistic: (state, action) => {
      const { key } = action.payload;
      state.shortenedLinks = state.shortenedLinks.map((link) =>
        link.key === key ? { ...link, status: link.status === 1 ? 0 : 1 } : link
      );

    },
    deleteLink: (state, action) => {
      state.shortenLinksfree = state.shortenLinksfree.filter(
        (link, index) => index !== action.payload
      );
    },
    removeFromFolderLink: (state, action) => {
      const link = state.shortenedLinks.find(link => link.key === action.payload.key);
      if (link) {
        link.folderId = null;
      }
    },
    cleanExpiredLinks: () => (dispatch, state) => {
      const now = new Date();
      const links = state.shortenLinksfree;
      const filteredLinks = links.filter((link) => new Date(link.expireAt) > now);
      localStorage.setItem("shortenLinkFree", JSON.stringify(filteredLinks));
      state.shortenLinksfree = filteredLinks
    },

    setLinks: (state, action) => {
      state.shortenLinksfree = action.payload;
    },
    resetError: (state) => {
      state.error = null;
    },
    clearLinks: (state) => {

      state.shortenedLinks = [];

    },
    togglePinLink: (state, action) => {

      const pin = state.shortenedLinks.find((link) => link.key === action.payload.key);
      if (pin) {
        pin.pin = !pin.pin;

      }

      state.shortenedLinks = processLink(state.shortenedLinks);

    }
  },
  extraReducers: (builder) => {
    builder
      // Handle shortenLinkLogged
      .addCase(shortenLinkLogged.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shortenLinkLogged.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(shortenLinkLogged.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(shortenLinkLoggedMulti.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shortenLinkLoggedMulti.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.response);
      })
      .addCase(shortenLinkLoggedMulti.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload || "Failed to shorten links ");
      })

      .addCase(shortenLinkFree.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shortenLinkFree.fulfilled, (state, action) => {
        state.loading = false;
        state.shortenLinksfree.unshift(action.payload);
        localStorage.setItem(
          "shortenLinkFree",
          JSON.stringify(state.shortenLinksfree)
        );
        toast.success("Link shortened successfully! 🚀");
      })
      .addCase(shortenLinkFree.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload || "Failed to shorten free link");
      })

      // Handle getLinks
      .addCase(getLinks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLinks.fulfilled, (state, action) => {
        state.loading = false;
        const { offset } = action.meta.arg;



        if (offset === 1) {

          state.shortenedLinks = processLink(action.payload);
        } else {

          const combined = [...state.shortenedLinks, ...action.payload];
          const unique = Array.from(new Map(combined.map(link => [link.key, link])).values());
          state.shortenedLinks = processLink(unique);
        }


        // toast.success("Links fetched successfully! 📚");
      })
      .addCase(getLinks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // toast.error(action.payload || "Failed to fetch links");
      })

      // Handle deleteShortLink
      .addCase(deleteShortLink.pending, (state) => {
        state.loading = true
      })
      .addCase(deleteShortLink.fulfilled, (state, action) => {
        state.loading = false
        state.shortenedLinks = state.shortenedLinks.filter(
          (link) => link.key !== action.payload.key
        );
        toast.success(action.payload.response.response);
      })
      .addCase(deleteShortLink.rejected, (state, action) => {
        // Check if action.payload contains a specific message
        state.loading = false
        toast.error(action.payload);

      })
      // Handle updateLink
      .addCase(updateLink.pending, (state, action) => {
        state.loading = true
      })
      .addCase(updateLink.fulfilled, (state, action) => {
        toast.success(action.payload.response);
        state.loading = false

      })
      .addCase(updateLink.rejected, (state, action) => {
        toast.error(action.payload || "Error updating link");
        state.loading = false

      })

      // Handle toggleKeyStatus
      .addCase(toggleKeyStatus.fulfilled, (state, action) => {
        if (typeof action.payload === "string") {

          const match = action.payload.match(/Key with name: '(.+?)'/);
          if (match && match[1]) {
            const keyName = match[1];
            const updatedLinks = state.shortenedLinks.map((link) => {
              if (link.key === keyName) {
                return {
                  ...link,
                  status: link.status === 1 ? 0 : 1,
                };
              }
              return link
            })
            state.shortenedLinks = updatedLinks;
          } else {
            // toast.success(action.payload);
          }
          return;
        }
      })
      .addCase(toggleKeyStatus.rejected, (state, action) => {
        // toast.error(action.payload || "Failed to toggle key status");
      })
      .addCase(LinkmoveInFolder.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(LinkmoveInFolder.fulfilled, (state, action) => {
        state.loading = false
        state.shortenedLinks = state.shortenedLinks.map((link) => {
          if (link.linkId === action.payload.key) {
            return {
              ...link,
              folderId: action.payload.folderId,
            };
          }
          return link;
        });
        toast.success(action.payload.response)
      })
      .addCase(LinkmoveInFolder.rejected, (state, action) => {
        state.loading = false
        toast.error(action.payload)
      })
  },
});

export const { resetError, cleanExpiredLinks, clearLinks, deleteLink, setLinks, toggleKeyStatusOptimistic, removeFromFolderLink, togglePinLink } = shortenLinkSlice.actions;

export default shortenLinkSlice.reducer;
